// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3a8d5829","455":"3077dea0"}[chunkId] + ".chunk.js";
};